import styled, { css } from 'styled-components/macro';

export const StyledInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ $unStyled }) =>
    !$unStyled &&
    css`
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 3px;
      padding: 12px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      transition: all 0.2s ease;

      &:hover {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    `}
`;

export const Title = styled.strong`
  font-size: ${({ fontbase }) => (fontbase ? 'var(--font-size-base)' : '0.8rem')};
  line-height: ${({ fontbase }) => (fontbase ? 'calc(var(--font-size-base) + 0.3125rem)' : '1.2')};
  display: block;
  margin-bottom: 6px;
  color: #374151;
  font-weight: 600;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.01em;
`;

export const Value = styled.span`
  font-size: ${({ fontbase }) => (fontbase ? 'var(--font-size-base)' : '1.5rem')};
  line-height: ${({ fontbase }) => (fontbase ? 'calc(var(--font-size-base) + 0.3125rem)' : '1.3')};
  color: #111827;
  display: ${({ isArrayValue }) => (isArrayValue ? 'block' : 'flex')};
  font-weight: 700;
  text-align: center;
  letter-spacing: -0.02em;
`;
